const comunicacao = require("./src/Comunicacao");

module.exports = {
    Comunicacao: comunicacao,
};